import * as types from '../actions/types'
import Immutable from 'immutable'

import { tableCols, findvalues } from '../containers/Usuarios'
import { isPrimitive, usuario } from '../utils/helpers'

const columnas = Immutable.fromJS(tableCols)

const INITIAL_STATE = Immutable.fromJS({
	usuarios: [],
	page: 1,
	showRecords: 100,
	totalRecords: 0,
	orderBy: {
		field: null,
		asc: false
	},
	modalCreate: {
		title: '',
		mode: '',
		areas: [],
		show: false,
		data: null,
		unchanged: null,
		btnDisabled: false,
	},
	modalDelete: {
		show: false,
		action: null,
		message: null
	},
	modalFilter: {
		show: false,
		filters: []
	},
})

export default function (state = INITIAL_STATE, action) {
	let id
	let data
	let index
	switch (action.type) {
		case types.OBTENER_USUARIOS:
			state = state.set('usuarios', Immutable.fromJS(action.payload.data))
			state = state.set('page', action.payload.page)
			state = state.set('totalRecords', action.payload.totalRecords)
			return state
		case types.CONMUTAR_SELECCION_USUARIO:
			state = state.setIn(['usuarios', action.payload.index, 'selected'], action.payload.checked)
			return state
		case types.CONMUTAR_SELECCION_TODOS_USUARIOS:
			state.get('usuarios').forEach((x, n) => {
				if (action.payload) {
					if (x.get('visible')) {
						state = state.setIn(['usuarios', n, 'selected'], action.payload)
					}
				} else {
					state = state.setIn(['usuarios', n, 'selected'], action.payload)
				}
			})
			return state
		case types.ORDENAR_USUARIOS:
			state = state.set('orderBy', action.payload.orderBy)
			return state
		case types.MOSTRAR_MODAL_CREAR_USUARIO:
			state = state.setIn(['modalCreate', 'show'], action.payload.show)
			state = state.setIn(['modalCreate', 'title'], action.payload.title)
			state = state.setIn(['modalCreate', 'mode'], action.payload.mode)
			state = state.setIn(['modalCreate', 'areas'], Immutable.fromJS(action.payload.areas))
			if (action.payload.mode === 'create') {
				state = state.setIn(['modalCreate', 'data'], Immutable.fromJS(usuario(action.payload.permisos, action.payload.grupos)))
				state = state.setIn(['modalCreate', 'unchanged'], state.setIn(['modalCreate', 'data']))
			} else if (action.payload.mode === 'edit') {
				state = state.setIn(['modalCreate', 'data'], Immutable.fromJS(action.payload.usuario))
				state = state.setIn(['modalCreate', 'unchanged'], Immutable.fromJS(action.payload.usuario))
			}
			return state
		case types.MODIFICAR_INPUTS_MODAL_CREATE_USUARIOS:
			state = state.setIn(['modalCreate', 'data', action.payload.attr], action.payload.value)
			return state
		case types.CREAR_ACTUALIZAR_USUARIO:
			id = action.payload.id
			index = state.get('usuarios').findIndex(x => x.get('id') === id)
			if (index !== -1) {
				state = state.setIn(['usuarios', index], Immutable.fromJS(action.payload))
			} else {
				state = state.set('usuarios', state.get('usuarios').push(Immutable.fromJS(action.payload)))
			}
			state = state.setIn(['modalCreate', 'show'], false)
			state = state.setIn(['modalCreate', 'title'], '')
			state = state.setIn(['modalCreate', 'mode'], '')
			state = state.setIn(['modalCreate', 'data'], null)
			return state
		case types.DESHABILITAR_BOTON_MODAL_USUARIOS:
			state = state.setIn(['modalCreate', 'btnDisabled'], action.payload)
			return state
		case types.MOSTRAR_MODAL_CONFIRMAR_ELIMINACION_USUARIO:
			state = state.setIn(['modalDelete', 'show'], action.payload.open)
			state = state.setIn(['modalDelete', 'action'], action.payload.action)
			state = state.setIn(['modalDelete', 'message'], action.payload.message)
			return state
		case types.ELIMINAR_USUARIO:
			index = state.get('usuarios').findIndex(x => x.get('id') === action.payload)
			state = state.deleteIn(['usuarios', index])
			state = state.setIn(['modalDelete', 'show'], false)
			state = state.setIn(['modalDelete', 'action'], null)
			state = state.setIn(['modalDelete', 'message'], null)
			return state
        case types.MOSTRAR_MODAL_CRITERIOS_FILTRADO_USUARIOS:
            state = state.setIn(['modalFilter', 'show'], action.payload)
            return state
        case types.ADICIONAR_CRITERIO_FILTRADO_USUARIOS:
            const firstCol = columnas.first()
            state = state.updateIn(['modalFilter', 'filters'], filter => filter
                .push(Immutable.fromJS({ 
                    column: firstCol.get('value'),
                    operator: '===',
                    value: '',
                    checked: false,
                    comparison: firstCol.get('type'),
                    apply: false
                }))
            )
            return state
        case types.ELIMINAR_CRITERIO_FILTRADO_USUARIOS:
            state = state.setIn(['modalFilter', 'filters'], state.getIn(['modalFilter', 'filters']).filter(item => !item.get('checked')))
            return state
        case types.CONMUTAR_SELECCION_CRITERIO_FILTRADO_USUARIOS:
            state = state.setIn(['modalFilter', 'filters', action.payload.index, 'checked'], action.payload.checked)
            return state
        case types.MODIFICAR_CRITERIO_FILTRADO_USUARIOS:
            if (action.payload.attr === 'column') {
                state = state.setIn(['modalFilter', 'filters', action.payload.index, 'comparison'], columnas.find(x => x.get('value') === action.payload.value).get('type'))
            }
            state = state.setIn(['modalFilter', 'filters', action.payload.index, action.payload.attr], action.payload.value)
            return state
        case types.APLICAR_CRITERIOS_FILTRADO_USUARIOS:
            state = state.updateIn(['modalFilter', 'filters'], filter => filter
                .map(x => {
                    x = x.set('apply', true)
                    return x
                })
            )
            return state
		case types.CAMBIAR_MOSTRAR_REGISTROS_USUARIOS:
            state = state.set('showRecords', action.payload)
            return state
		case types.MODIFICAR_INPUTS_USUARIOS:
            if (isPrimitive(action.payload.value)) {
    			state = state.setIn(`${action.payload.path}`.split('.'), action.payload.value)
            } else {
                if (action.payload.immutable === false) {
                    state = state.setIn(`${action.payload.path}`.split('.'), action.payload.value)
                } else {
                    state = state.setIn(`${action.payload.path}`.split('.'), Immutable.fromJS(action.payload.value))
                }
            }
            return state
		default:
			return state
	}
}



// WEBPACK FOOTER //
// ./src/reducers/usuarios.js